import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet, interactiveTransition } from 'modules/v2/foundation/theme';
const activeTabStyles = css `
  color: ${themeGet('colors.text.300')};
  background-color: ${themeGet('colors.background.100')};

  &:disabled {
    // Shouldn't happen, but just in case
    color: ${themeGet('colors.disabled.200')};
  }
`;
const hoverTabStyles = css `
  background-color: ${themeGet('colors.background.75')};
`;
export const TabNavContainer = styled.div `
  display: flex;
  height: ${pxToRem(40)};
  background-color: ${themeGet('colors.background.50')};
  border-bottom: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
`;
export const ScrollableTabNav = styled.div `
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  scrollbar-width: none;
  overflow-x: auto;
  overflow-y: hidden;
`;
export const ContentContainer = styled.div ``;
export const TabContainer = styled.button `
  height: ${pxToRem(28)};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${themeGet('spacing.sm')};
  position: relative;
  cursor: pointer;
  appearance: none;
  border: 0;
  ${interactiveTransition};
  white-space: nowrap;
  flex: 0 1 auto;

  color: ${themeGet('colors.text.100')};
  padding: ${themeGet('spacing.sm')} ${themeGet('spacing.md')};
  border-radius: ${themeGet('borderRadius.md')};
  background-color: transparent;

  ${({ $stretch }) => $stretch &&
    css `
      flex: 1 1 auto;
    `}

  &:not(:last-child) {
    margin-right: ${themeGet('spacing.md')};
  }

  &:hover:not(:disabled) {
    ${hoverTabStyles};
  }

  &:focus-visible {
    outline-offset: ${pxToRem(-1)};
    outline: ${pxToRem(1)} solid ${themeGet('colors.focus.info')};
  }

  ${(props) => props.$isActive && activeTabStyles};

  &:disabled {
    color: ${themeGet('colors.disabled.200')};
    cursor: auto;
  }
`;
export const TabBadge = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${themeGet('spacing.sm')};
  border-radius: ${themeGet('borderRadius.lg')};
  background-color: ${themeGet('colors.background.100')};
  height: ${pxToRem(16)};
  min-width: ${pxToRem(16)};

  ${interactiveTransition};

  ${(props) => props.$isActive &&
    `
    background-color: ${themeGet('colors.background.50')};
    `}
`;
